import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { TagService } from '../../core/tag.service';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';
import { ActionsApiService } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>Add Tags to "{{ actionList.name }}"</h2>
    <mat-dialog-content>
      <mat-spinner [strokeWidth]="4" [diameter]="40" *ngIf="tagsLoading"></mat-spinner>
      <ng-container *ngIf="!tagsLoading">
        <va-multi-select
          [options]="tags"
          [selected]="selectedTags"
          [placeholderText]="'Select tag(s)...'"
          [allowNew]="true"
        ></va-multi-select>
        <p class="alert-warning">These tags will be added to all accounts on this list.</p>
      </ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" [disabled]="selectedTags.length === 0" (click)="addTags()">
        <ng-container *ngIf="!buttonLoading; else loading">Add Tags</ng-container>
        <ng-template #loading>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">Cancel</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class AddTagsDialogComponent extends ActionListDialogComponent implements OnInit {
  tags: string[];
  selectedTags: string[] = [];
  tagsLoading = true;
  buttonLoading = false;

  constructor(
    public dialogRef: MatDialogRef<AddTagsDialogComponent>,
    public router: Router,
    private tagService: TagService,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  ngOnInit(): void {
    this.tagService.tags.subscribe((tags) => {
      this.tagsLoading = false;
      this.tags = tags;
    });
    this.tagsLoading = true;
    this.tagService.loadAllTags();
  }

  addTags(): void {
    if (this.buttonLoading || this.selectedTags.length === 0) {
      return;
    }

    this.buttonLoading = true;

    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.addTagsBulkAction(this.actionList.id, this.selectedTags);
    } else {
      response$ = this.actionsService.addTagsToList(this.actionList.id, this.selectedTags);
    }
    response$.subscribe({
      next: () => {
        this.snackbarService.successSnack(`Adding tags to ${this.actionList.name}.`);
        this.dialogRef.close(true);
        this.buttonLoading = false;
      },
      error: () => {
        this.snackbarService.errorSnack(`Failed to add tags to ${this.actionList.name}. Please try again.`);
        this.buttonLoading = false;
      },
    });
  }
}
